import type { SkillCatalogSkill } from "connected-components/skills/types"

function byName(left: SkillCatalogSkill, right: SkillCatalogSkill): number {
  return left.name.localeCompare(right.name)
}

export function orderSkillsForDisplay(skills: SkillCatalogSkill[], isEnabled: (skillId: string) => boolean): SkillCatalogSkill[] {
  const enabled = skills.filter((skill) => isEnabled(skill.id)).sort(byName)
  const disabled = skills.filter((skill) => !isEnabled(skill.id)).sort(byName)
  return [...enabled, ...disabled]
}

export function applyHeldOrder(skills: SkillCatalogSkill[], heldIds: string[]): SkillCatalogSkill[] {
  const rank = new Map(heldIds.map((skillId, index) => [skillId, index]))
  const held = skills
    .filter((skill) => rank.has(skill.id))
    .sort((left, right) => (rank.get(left.id) ?? 0) - (rank.get(right.id) ?? 0))
  const fresh = skills.filter((skill) => !rank.has(skill.id)).sort(byName)
  return [...held, ...fresh]
}
